'use client'
import React from 'react'
import CustomLink from '@/shared/components/customLink'
import TeamPlaceholder from '@/assets/images/placeholder/team.png'
import { convertDt24hFormat, dateCheck, getSlugUrl } from '@/shared/utils'
import { S3_PREFIX } from '@/shared/constants'
import MyImage from '@/shared/components/myImage'
import { useQuery } from '@apollo/client'
import { UPCOMING_MATCHES } from '@/graphql/globalwidget/rankings.query'

function UpcomingMatches() {
  const { data } = useQuery(UPCOMING_MATCHES, {
    variables: {
      input: {
        nLimit: 5,
        nOrder: 1,
        nSkip: 0,
        sSortBy: 'dStartDate'
      }
    }
  })

  if (data?.listUpcomingMatches?.length === 0) return null

  return (
    <section className="widget">
      <div className="widget-title flex justify-between items-center mb-4 mt-3">
        <h3 className="font-bold text-lg mb-0 text-textOffWhite flex items-center justify-center md:justify-start">
          Upcoming Matches
        </h3>
      </div>
      <div className="font-semibold">
        <div>
          {data?.listUpcomingMatches?.map((data: any, i: number) => {
            return (
              <div
                key={i}
                className="relative py-4 px-3 border border-tabBorder  rounded-xl mb-3 font-normal bg-cardBg "
              >
                <div className={`flex justify-between items-center `}>
                  <div className={`font-semibold flex items-center`}>
                    <div className="w-8 flex-shrink-0">
                      <MyImage
                        className="rounded-full aspect-square"
                        src={
                          data?.oTeamA?.oImg?.sUrl
                            ? `${S3_PREFIX}${data?.oTeamA?.oImg?.sUrl}`
                            : TeamPlaceholder
                        }
                        placeholderImage={TeamPlaceholder}
                        loadOnScroll
                        width={33}
                        height={33}
                        alt={data?.oTeamA?.oImg?.sText}
                        sizes="(max-width: 767px) 33px, (max-width: 991px) 33px, (max-width: 1190px) 200px, 33px"
                      />
                    </div>
                    <span className="ml-2 text-sm text-[#CED2D5] md:w-10 text-left font-bold text-ellipsis overflow-hidden whitespace-nowrap">
                      {data?.oTeamA?.sAbbr}
                    </span>
                  </div>
                  <p className="mb-0 text-base text-textDselected">VS</p>
                  <div className={`font-semibold flex items-center`}>
                    <span className="mr-2 text-sm text-[#CED2D5] md:w-10 text-right font-bold text-ellipsis overflow-hidden whitespace-nowrap">
                      {data?.oTeamB?.sAbbr}
                    </span>
                    <div className="w-8 flex-shrink-0">
                      <MyImage
                        className="rounded-full aspect-square"
                        src={
                          data?.oTeamB?.oImg?.sUrl
                            ? `${S3_PREFIX}${data?.oTeamB?.oImg?.sUrl}`
                            : TeamPlaceholder
                        }
                        placeholderImage={TeamPlaceholder}
                        loadOnScroll
                        width={33}
                        height={33}
                        alt={data?.oPlayer?.oImg?.sText}
                        sizes="(max-width: 767px) 33px, (max-width: 991px) 33px, (max-width: 1190px) 200px, 33px"
                      />
                    </div>
                  </div>
                </div>
                <p className="mb-0 text-textDselected text-xs font-medium text-center mt-2.5">
                  {convertDt24hFormat(dateCheck(data?.dStartDate))}
                </p>
                {data?.oSeo?.sSlug ? (
                  <CustomLink
                    href={getSlugUrl(`/${data?.oSeo?.sSlug}`)}
                    className="h-full w-full absolute top-0 left-0 opacity-0 z-10"
                    prefetch={false}
                  >
                    link
                  </CustomLink>
                ) : null}
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default UpcomingMatches
